var _circle, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSuuportLink(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 51,
    viewBox: "0 0 50 51",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 25,
    cy: 25.5,
    r: 25,
    fill: "white"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_9641_177273)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25 14.5C23.0109 14.5 21.1032 15.2902 19.6967 16.6967C18.2902 18.1032 17.5 20.0109 17.5 22V23.5H19C19.3978 23.5 19.7794 23.658 20.0607 23.9393C20.342 24.2206 20.5 24.6022 20.5 25V29.5C20.5 29.8978 20.342 30.2794 20.0607 30.5607C19.7794 30.842 19.3978 31 19 31H17.5C17.1022 31 16.7206 30.842 16.4393 30.5607C16.158 30.2794 16 29.8978 16 29.5V22C16 20.8181 16.2328 19.6478 16.6851 18.5558C17.1374 17.4639 17.8003 16.4718 18.636 15.636C19.4718 14.8003 20.4639 14.1374 21.5558 13.6851C22.6478 13.2328 23.8181 13 25 13C26.1819 13 27.3522 13.2328 28.4442 13.6851C29.5361 14.1374 30.5282 14.8003 31.364 15.636C32.1997 16.4718 32.8626 17.4639 33.3149 18.5558C33.7672 19.6478 34 20.8181 34 22V31C34 31.9946 33.6049 32.9484 32.9016 33.6516C32.1984 34.3549 31.2446 34.75 30.25 34.75H27.049C26.9174 34.978 26.728 35.1674 26.5 35.299C26.272 35.4307 26.0133 35.5 25.75 35.5H24.25C23.8522 35.5 23.4706 35.342 23.1893 35.0607C22.908 34.7794 22.75 34.3978 22.75 34C22.75 33.6022 22.908 33.2206 23.1893 32.9393C23.4706 32.658 23.8522 32.5 24.25 32.5H25.75C26.0133 32.5 26.272 32.5693 26.5 32.701C26.728 32.8326 26.9174 33.022 27.049 33.25H30.25C30.8467 33.25 31.419 33.0129 31.841 32.591C32.2629 32.169 32.5 31.5967 32.5 31H31C30.6022 31 30.2206 30.842 29.9393 30.5607C29.658 30.2794 29.5 29.8978 29.5 29.5V25C29.5 24.6022 29.658 24.2206 29.9393 23.9393C30.2206 23.658 30.6022 23.5 31 23.5H32.5V22C32.5 21.0151 32.306 20.0398 31.9291 19.1299C31.5522 18.2199 30.9997 17.3931 30.3033 16.6967C29.6069 16.0003 28.7801 15.4478 27.8701 15.0709C26.9602 14.694 25.9849 14.5 25 14.5Z",
    fill: "#4A3AFF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_9641_177273"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(13 13)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuuportLink);
export default __webpack_public_path__ + "static/media/suuport-link.90a49206f3177f79776dbbfec7bfd528.svg";
export { ForwardRef as ReactComponent };